import { useEffect, useState } from 'react';

/** True once the page has scrolled past 16px — mockup updateHeader() (L1101–1106). */
export const useCondensedHeader = (): boolean => {
  const [condensed, setCondensed] = useState(false);
  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        setCondensed((window.scrollY || document.documentElement.scrollTop || 0) > 16);
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
  return condensed;
};

export default useCondensedHeader;
